
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/reviews-and-testimonials",
      function () {
        return require("private-next-pages/reviews-and-testimonials.tsx");
      }
    ]);
  